import { createCardStore, type LocalStore } from "./store.ts";

// Ponto único de criação do store: réplica IndexedDB + fila de saída + sync (store.ts). Guia: API.md.
export function createStore(): LocalStore {
  return createCardStore();
}
export { clearLocalData, type SharedItem } from "./db.ts";
export type { LocalStore } from "./store.ts";
export type { BatchAction, CardStore, ImportReport, Notice, PrefValues, SyncStatus } from "./types.ts";
